import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Apps from './components/Apps'
import Developers from './components/Developers'
import Users from './components/Users'
import NotFound from './views/NotFound';
import Auth from './views/Auth';
import Forbidden from './views/Forbidden';
import { Auth as AuthHelper } from './api';
import accessMap from './accessMap';

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!AuthHelper.isAuthenticated) {
    next();
    return
  }
  next('/home')
};

const ifAuthenticated = (to, from, next) => {
  if (AuthHelper.isAuthenticated && accessMap[to.name] && accessMap[to.name].indexOf(AuthHelper.user.role) === -1)
    next('/forbidden');
  else if (AuthHelper.isAuthenticated)
    next();
  else
    next('/auth')
};

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home/apps',
    },
    {
      path: '/home',
      name: 'home',
      redirect: '/home/apps',
      component: Home,
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '/home/apps',
          name: 'apps',
          component: Apps,
          beforeEnter: ifAuthenticated
        },
        {
          path: '/home/developers',
          name: 'developers',
          component: Developers,
          beforeEnter: ifAuthenticated
        },
        {
          path: '/home/users',
          name: 'users',
          component: Users,
          beforeEnter: ifAuthenticated
        }
      ]
    },
    {
      path: '/404',
      component: NotFound,
      name: 'notFound'
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/forbidden',
      name: 'forbidden',
      component: Forbidden
    },
    {
      path: '*',
      redirect: '/404'
    },
  ]
})